import React from 'react';
import { TechtonAttribution } from './TechtonAttribution';

/**
 * Demo component showing different ways to use the TechtonAttribution widget
 */
export const TechtonAttributionDemo: React.FC = () => {
  return (
    <div className="p-8 bg-slate-900 text-white">
      <h1 className="text-2xl font-bold mb-8">Techton Attribution Widget Examples</h1>
      
      <div className="grid gap-8">
        <div className="bg-slate-800 p-6 rounded-lg">
          <h2 className="text-lg font-semibold mb-4">Default Style</h2>
          <TechtonAttribution />
          <div className="mt-4 bg-slate-900/50 p-4 rounded-lg">
            <pre className="text-xs text-gray-300 overflow-x-auto">
              {'<TechtonAttribution />'}
            </pre>
          </div>
        </div>
        
        <div className="bg-slate-800 p-6 rounded-lg">
          <h2 className="text-lg font-semibold mb-4">Centered with Custom Colors</h2>
          <div className="flex justify-center">
            <TechtonAttribution 
              textColor="text-gray-200" 
              accentColor="text-blue-400" 
            />
          </div>
          <div className="mt-4 bg-slate-900/50 p-4 rounded-lg">
            <pre className="text-xs text-gray-300 overflow-x-auto">
              {'<div className="flex justify-center">\n  <TechtonAttribution \n    textColor="text-gray-200" \n    accentColor="text-blue-400" \n  />\n</div>'}
            </pre>
          </div>
        </div>
        
        <div className="bg-slate-800 p-6 rounded-lg">
          <h2 className="text-lg font-semibold mb-4">Purple Theme</h2>
          <TechtonAttribution 
            accentColor="text-purple-400"
          />
          <div className="mt-4 bg-slate-900/50 p-4 rounded-lg">
            <pre className="text-xs text-gray-300 overflow-x-auto">
              {'<TechtonAttribution accentColor="text-purple-400" />'}
            </pre>
          </div>
        </div>
      </div>
      
      <div className="mt-8 bg-slate-800 p-6 rounded-lg">
        <h2 className="text-lg font-semibold mb-4">HTML/CSS Only Version (No React Required)</h2>
        <div className="bg-slate-900/50 p-4 rounded-lg">
          <pre className="text-xs text-gray-300 overflow-x-auto whitespace-pre-wrap">
{`<!-- Powered by Techton Badge -->
<div style="display: flex; align-items: center;">
  <span style="font-family: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; font-weight: 500; color: white;">Powered By</span>
  <a 
    href="https://techton.cloud/" 
    target="_blank" 
    rel="noopener noreferrer" 
    style="margin-left: 8px; color: #22d3ee; font-weight: bold; text-decoration: none; transition: opacity 0.3s; background-color: rgba(30, 41, 59, 0.5); padding: 4px 12px; border-radius: 8px; border: 1px solid rgba(34, 211, 238, 0.3); box-shadow: 0 4px 6px -1px rgba(34, 211, 238, 0.1);"
    onmouseover="this.style.opacity='0.8'" 
    onmouseout="this.style.opacity='1'"
  >
    Techton
  </a>
</div>`}
          </pre>
        </div>
      </div>
    </div>
  );
};